import { FormationDetailProps } from '@/types/formation';

export const esiFormation: FormationDetailProps = {
  id: '8',
  title: 'Formation ESI (Equipier de Seconde Intervention)',
  description: "Formez-vous aux techniques avancées d'intervention en cas d'incendie, maîtrisez les procédures d'extinction et d'évacuation, et devenez un maillon essentiel de la chaîne de secours interne.",
  duration: '7 heures (1 jour)',
  category: 'Incendie',
  imageSrc: '/images/formations/esi.webp',
  slug: 'equipier-seconde-intervention',
  reference: 'F-ESI',
  price: 'Sur devis – nous contacter',
  targetAudience: "Responsable et agent de sécurité, personnel de maintenance, personnel désigné des équipe incendie",
  prerequisites: 'Être âgé de 18 ans\nÊtre apte médical',
  objectives: [
    "Identifier les indices démontrant et conjectifs de naissance et de propagation d'un incendie",
    "Utiliser efficacement et en sécurité l'ensemble des moyens dédiés aux supports de première intervention",
    "Appliquer les consignes de sécurité incendie et d'évacuation",
    "Appliquer plusieurs étapes d'intervention, reconnaissance, alerte, mise en sécurité, protection incendie, second recours des secours extérieur"
  ],
  program: [
    {
      title: 'Partie théorique 40%',
      items: [
        'Programme adaptable aux spécificités et demande du client',
        "L'organisation de la lutte contre l'incendie",
        'Les causes principales des incendies',
        "Naissance et évolution d'un feu",
        "Les classes d'un incendie",
        'Le triangle du feu',
        'Les classes de feu',
        'Les modes de propagation du feu',
        "Les procédés d'extinction",
        "Les moyens d'extinction",
        'Les fonctions et rôles des agents extincteurs',
        "Principe de fonctionnement, utilisation d'un extincteur et d'un RIA et leurs champs d'application",
        "Autre moyens d'extinction",
        "Rôle et les missions de l'ESI",
        'Consigne de sécurité',
        'Alerte des secours'
      ]
    },
    {
      title: 'Equipements de protection collective et individuelle',
      items: [
        'Les facteurs aggravants',
        'Les fumées',
        'Le confinement du partage',
        "L'appareil Respiratoire Isolant",
        "Domaine d'utilisation",
        'Description et fonctionnement',
        'Conduite à tenir en atmosphère viciée ou non',
        'Technique de reconnaissance',
        "Contrôles préparatoire"
      ]
    },
    {
      title: 'Les consignes réseau et transmission radio',
      items: [
        "Le matériel flottant l'évacuation",
        'Les signaux sonores',
        'Les fiches réflexe',
        "La signalétique et l'éclairage",
        'Les portes coupe-feu',
        'Les déclenchements manuels',
        'Le désenfumage',
        'Connaissance du point de rassemblement',
        'Zones de refuge',
        'Accès des secours extérieurs',
        "Conduite à tenir en cas d'alarme et d'évacuation",
        "Schémas de l'évacuation",
        'Rôle du guide file, serre file',
        "Dispositifs d'aide à l'évacuation",
        'La prévention des incendies',
        'Règles de préventions',
        "Exercice d'évacuation",
        'Conduite à tenir particulières',
        "La prise en charge d'une personne brûlée ou intoxiquée",
        'La prime feu',
        "L'objectif du document et les règles de sécurité",
        "Nation d'hydraulique",
        'Rappel théorique de la combustion',
        'Les reconnaissements',
        "Les coupes d'énergies",
        "Les limites d'explosivité",
        'Les zones ATEX'
      ]
    },
    {
      title: 'Partie pratique 60%',
      items: [
        'Exercices pratiques sur feux réels',
        'Mises en œuvre un extincteur Eau Pulvérisée 6 Litres à pression auxiliaire',
        'Mises en œuvre un extincteur CO2 à pression permanente',
        'Mises en œuvre du matériel spécifique du ESI',
        "Exercice de réalisation d'établissement hydraulique",
        'Dévider un tuyau en tirage direct',
        "Exercice en binôme, lancement de commandes d'une lance à incendie",
        'Ordre lance établie en plein',
        "Exercice d'amené au port de l'ARI"
      ]
    },
    {
      title: 'Exercice de reconnaissance',
      items: [
        'Exercice de reconnaissance avec ARI pour moyens hydrauliques',
        "Visite de l'établissement, repérage des circuits d'évacuation et du matériel incendie"
      ]
    }
  ],
  pedagogicalMethods: [
    'Nous travaillons avec élève en situation réelle',
    'Exposés interactifs, démonstrations par le formateur',
    'Support informatique, utilisation vidéoprojecteur, paperboard',
    'Exercice sur feux réels sur générateur de flamme sans eau, avec extincteur de formation'
  ],
  evaluationMethods: [
    "En jour de la formation : Questionnaire des besoins et positionnement de l'apprenant",
    'Pendant la formation : Atelier pratique en situation réelle + exercice applicable',
    'Fin de formation : QCM pour évaluation des acquis + évaluation de satisfaction à chaud',
    "Après la formation : Évaluation à froid pour vérifier les compétences de l'apprenant"
  ],
  certification: "Cette action de formation sera validée par une attestation de compétence nominative, après la réalisation du QCM final par l'apprenant.",
  registrationProcess: [
    'Inscription par téléphone, par email ou par le site internet',
    "Délai d'accès selon un agenda interne (le session de rattrapage transitoire 10 jours avant le début de la formation)"
  ],
  accessibilityCriteria: "Pour toute personne en situation d'handicap, Nous sommes susceptibles d'accueille les personnes moins de nous contacter au préalable pour étudier toute situation.",
  formatterInfo: {
    name: 'Sebastien Davrainville - SDPSI Formation',
    phone: '06.22.61.04.09',
    email: 'sdpsiformation@orange.fr',
    website: 'www.sdpsi-formations.fr'
  }
};
